import { render, staticRenderFns } from "./Masker1.vue?vue&type=template&id=6670eea4&scoped=true"
import script from "./Masker1.vue?vue&type=script&lang=js"
export * from "./Masker1.vue?vue&type=script&lang=js"
import style0 from "./Masker1.vue?vue&type=style&index=0&id=6670eea4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670eea4",
  null
  
)

export default component.exports